import React from 'react';

import styled from '@emotion/styled';

import { Modal } from '../../../components/Modals/Modal';
import { ModalProvider } from '../../../context/ModalContext';
import ModalTriggerContainer from '../../../components/Modals/ModalTriggerContainer';
import JobsCreatedTable from './JobsTable/JobsCreatedTable';

const InviteToApplyButton = ({
  name,
  button,
  invitedUserId
}: {
  name: string;
  button?: boolean;
  invitedUserId: string
}) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer>
        {button ? (
          <Button>Invite to Apply</Button>
        ) : (
          <TextDescription>Invite to Apply</TextDescription>
        )}
      </ModalTriggerContainer>
      <Modal>
        <JobsCreatedTable name={name} invitedUserId={invitedUserId}/>
      </Modal>
    </ModalProvider>
  );
};

export default InviteToApplyButton;

const TextDescription = styled.div`
  color: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -2%;
  text-wrap: nowrap;
  cursor: pointer;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const Button = styled.button`
  display: grid;
  place-content: center;
  color: white;
  font-weight: 500;
  font-size: 14px;
  height: fit-content;
  border-radius: 4px;
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.palette.mainBlue};
  cursor: pointer;
  width: 10rem;
  border: none;

  &.purple {
    background-color: ${({ theme }) => theme.palette.mainPurple};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.palette.greyGrey2};
  }
`;
